/* 🤖 this file was generated by script */
export const wsolidiconMessageCircle01 = {
  name: 'message_circle_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M3 11.5a9.5 9.5 0 1 1 5.9 8.8h-.01l-.16.01-5.16.53q-.33.04-.62.05c-.19 0-.52 0-.84-.2a1.5 1.5 0 0 1-.7-1.05c-.06-.37.06-.69.13-.86q.12-.27.28-.56l1.66-3.05.13-.26v-.03l-.11-.34A10 10 0 0 1 3 11.5" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
